<div class="card" *appIsGranted="['PACKETS_EVENTS', 'PACKETS_EVENTS', 'READ']">
  <div class="card-body column">
    <div class="card mb-4">
      <div class="row">
        <h6 class="card">Pesquisa de Eventos</h6>
        <div class="col">
          <div class="col" style="display: inline-flex">
            <label>Serial</label>
            <input class="ms-2" placeholder="205502151" [(ngModel)]="serial" />
          </div>
        </div>
        <div class="col">
          <div class="mb-2">
            <label class="d-block mb-1" style="font-size: smaller">
              Origem Mensagem
            </label>
            <ng-select
              class="custom"
              placeholder="Origem Mensagem"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="filterMessageOriginSelect"
              [searchable]="true"
              [multiple]="true"
              (change)="
                getEventsFilter(filterEventsSelect, filterMessageOriginSelect)
              "
              [markFirst]="true"
            >
              <ng-option
                *ngFor="let origin of messageOrigin"
                [value]="origin.id"
              >
                {{ origin.name }}
              </ng-option>
            </ng-select>
          </div>
        </div>
        <div class="col">
          <div style="inline-size: max-content">
            <label>Data inicial</label>
            <input type="datetime-local" step="1" [(ngModel)]="dateStart" />
          </div>
          <div style="inline-size: max-content">
            <label class="me-2">Data Final</label>
            <input type="datetime-local" step="1" [(ngModel)]="dateEnd" />
          </div>
        </div>

        <div class="col">
          <label> Opções </label>
          <div class="d-inline">
            <input
              class="form-check-input ms-2"
              type="radio"
              name="formRadios"
              id="formRadios1"
              value="0"
              [(ngModel)]="prettyEvent"
              checked
            />
            <label class="form-check-label" for="formRadios1"> 0 </label>
            <input
              class="form-check-input ms-2"
              type="radio"
              name="formRadios"
              id="formRadios2"
              value="1"
              [(ngModel)]="prettyEvent"
            />
            <label class="form-check-label" for="formRadios2"> 1 </label>
            <input
              class="form-check-input ms-2"
              type="radio"
              name="formRadios"
              id="formRadios3"
              value="2"
              [(ngModel)]="prettyEvent"
            />
            <label class="form-check-label" for="formRadios3"> 2 </label>
          </div>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-2">
          <div class="d-flex align-items-center">
            <label> Filtro Eventos </label>
            <button
              type="button"
              class="btn btn-sm btn-primary ms-1"
              ngbTooltip="Se marcado, não mostra apenas o evento selecionado"
              [ngClass]="{
                'btn-danger': logicNOT,
                'btn-secondary': !logicNOT
              }"
              (click)="changeLogicFilter()"
            >
              NOT
            </button>
          </div>
        </div>
        <div [ngClass]="hasTagSource ? 'col-4' : 'col-6'">
          <ng-select
            class="custom"
            id="fileTypeSelect"
            placeholder="Selecione um tipo de evento"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="filterEventsSelect"
            [multiple]="true"
            [searchable]="true"
            (change)="
              getEventsFilter(filterEventsSelect, filterMessageOriginSelect)
            "
            [markFirst]="true"
          >
            <ng-option *ngFor="let event of events" [value]="event.id">
              <div [ngbTooltip]="event.name">
                {{ event.name }}
              </div>
            </ng-option>
          </ng-select>
        </div>

        <div class="col-2 d-flex align-items-center" *ngIf="hasTagSource">
          <label class="mb-0 me-1" style="font-size: 12px">Source</label>
          <ng-select
            class="custom source-select flex-grow-1"
            placeholder="Source"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="filterTagSourceSelect"
            [items]="tagSources"
            bindLabel="name"
            bindValue="id"
            [clearable]="false"
            [searchable]="false"
            (change)="onTagSourceChange($event)"
          >
          </ng-select>
        </div>

        <div class="col-2">
          <div class="dropdown" ngbDropdown>
            <button
              class="btn btn-sm btn-primary dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              ngbDropdownToggle
            >
              Ações <i class="mdi mdi-chevron-down"></i>
            </button>
            <div
              class="dropdown-menu"
              aria-labelledby="dropdownMenuButton"
              ngbDropdownMenu
            >
              <a
                *appIsGranted="[
                  'PACKETS_EVENTS',
                  'PACKETS_EVENTS_ANALYTICS',
                  'READ'
                ]"
                class="btn dropdown-item"
                (click)="
                  positionEventJsonList.length > 0
                    ? openModal(modalAnalytics)
                    : null
                "
                >Análise</a
              >
              <a class="btn dropdown-item" (click)="exportExcel()"
                >Exportar Excel</a
              >
              <a
                class="btn dropdown-item"
                (click)="
                  mapActiveFlag && positionEventJsonList.length > 0
                    ? getErbs()
                    : null
                "
                >Requisitar erb último evento</a
              >
              <a
                class="btn dropdown-item"
                [ngStyle]="{
                  'background-color': !mapActiveFlag ? 'yellow' : ''
                }"
                (click)="initMap(); mapActiveFlag = !mapActiveFlag"
                >Desativar Mapa</a
              >
              <a
                class="btn dropdown-item"
                ngbTooltip="Mostra o marcador do campo gps também, se for diferente da lat e lng do campo p2p."
                [ngStyle]="{
                  'background-color': !mapActiveFlag
                    ? 'yellow'
                    : markerFilterLoRaP2PGpsLatFlag
                    ? 'green'
                    : ''
                }"
                (click)="
                  markerFilterLoRaP2PGpsLatFlag = !markerFilterLoRaP2PGpsLatFlag
                "
                >Marcador adicional detectado</a
              >
              <a
                class="btn dropdown-item"
                [ngStyle]="{
                  'background-color': !mapActiveFlag ? 'yellow' : ''
                }"
                (click)="
                  lineBetweenMarkers > 2
                    ? (lineBetweenMarkers = 0)
                    : (lineBetweenMarkers = lineBetweenMarkers + 1)
                "
                ><div *ngIf="lineBetweenMarkers == 0">
                  Linhas entre marcadores:<br />Tudo
                </div>
                <div *ngIf="lineBetweenMarkers == 1">
                  Linhas entre marcadores:<br />GSM e 4G
                </div>
                <div *ngIf="lineBetweenMarkers == 2">
                  Linhas entre marcadores:<br />Entre mesmo seq
                </div>
                <div *ngIf="lineBetweenMarkers == 3">
                  Linhas entre marcadores:<br />Nenhum
                </div></a
              >
              <a class="m-1">
                <input
                  [(ngModel)]="textHighlight"
                  placeholder="Marcar um texto"
                />
              </a>
            </div>
          </div>
        </div>
        <div class="col-2">
          <button
            type="button"
            class="btn btn-primary btn-sm"
            (click)="searchEvents()"
          >
            Pesquisar
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm"
            (click)="searchEventsWithProtoEvent()"
            >
            Pesquisar Proto
          </button>
        </div>
      </div>
    </div>

    <div class="card align-items-center" *ngIf="circularProgressiveWait">
      <div card="card-body mt-n3">
        <div class="spinner-border text-primary m-1" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="w-100">
        <as-split direction="horizontal">
          <as-split-area [size]="mapActiveFlag ? 60 : 100">
            <ng-container *ngIf="!circularProgressiveWait">
              <div [fluidHeight] style="min-height: 80vh">
                <div
                  class="card p-2 mb-n2"
                  *ngFor="let position of positionEventJsonList; let i = index"
                >
                  <div>
                    <button
                      class="btn btn-sm btn-purple btn-rounded me-2"
                      (click)="setCenterPositionOnMapAndOpenInfoBox(i)"
                    >
                      {{ positionEventJsonList.length - i }}
                    </button>
                    <span style="color: red; font-weight: bold"
                      >{{ position.data_hora_evento }} -
                      {{ position.tipo_evento }}
                    </span>
                  </div>
                  <div *ngIf="prettyEvent == '0'">
                    <p
                      [innerHTML]="
                        position
                          | jsonToStringPipe
                          | highlightSearch : textHighlight
                      "
                    ></p>
                  </div>
                  <div *ngIf="prettyEvent == '1'">
                    <ngx-json-viewer
                      [json]="position"
                      [expanded]="false"
                    ></ngx-json-viewer>
                  </div>
                  <div *ngIf="prettyEvent == '2'">
                    <ngx-json-viewer
                      [json]="position"
                      [depth]="3"
                    ></ngx-json-viewer>
                  </div>
                </div>
              </div>
            </ng-container>
          </as-split-area>
          <as-split-area [size]="mapActiveFlag ? 40 : 0">
            <div class="d-inline">
              <div id="map" class="w-100 h-100" [fluidHeight]></div>
              <div class="card align-items-center" *ngIf="!maps">
                <div card="card-body mt-n3">
                  <p>Carregando o mapa</p>
                  <div class="spinner-border text-primary m-1" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
              <div>
                <span class="badge rounded-pill badge-outline-dark ms-1">
                  <img
                    src="../../../assets/images/positionArrow/arrow-ok.svg"
                    alt=""
                    class="rounded avatar-xs"
                  />

                  <label>GPS:True Online:True</label>
                </span>
                <span class="badge rounded-pill badge-outline-dark ms-1">
                  <img
                    src="../../../assets/images/positionArrow/arrow-sem-gps.svg"
                    alt=""
                    class="rounded avatar-xs"
                  />
                  <label>GPS:False Online:True</label>
                </span>
                <span class="badge rounded-pill badge-outline-dark ms-1">
                  <img
                    src="../../../assets/images/positionArrow/arrow-memoria.svg"
                    alt=""
                    class="rounded avatar-xs"
                  />
                  <label>GPS:True Online:False</label>
                </span>
                <span class="badge rounded-pill badge-outline-dark ms-1">
                  <img
                    src="../../../assets/images/positionArrow/arrow-sem-gps-memoria.svg"
                    alt=""
                    class="rounded avatar-xs"
                  />
                  <label>GPS:False Online:False</label>
                </span>
                <span class="badge rounded-pill badge-outline-dark ms-1">
                  <img
                    src="../../../assets/images/carrinho-p2p.png"
                    alt=""
                    class="rounded avatar-xs"
                  />
                  <label>Pacote P2P</label>
                </span>
                <span class="badge rounded-pill badge-outline-dark ms-1">
                  <img
                    src="../../../assets/images/tower.png"
                    alt=""
                    class="rounded avatar-xs"
                  />
                  <label>Pacote LoRaWAN</label>
                </span>
              </div>
            </div>
          </as-split-area>
        </as-split>
      </div>
    </div>
    <div>
      <ng-container
        *ngIf="modalInstance == undefined || modalInstance._closed.closed"
      >
        <div
          class="mini-window"
          [ngClass]="{
          'minimize': btnMinimizeCountEventTypeWindow,
        }"
        >
          <table>
            <thead class="border-count-events-bottom">
              <th></th>
              <th class="border-count-events-left">Total</th>
              <ng-container *ngFor="let origin of countEventType.messageOrigin">
                <ng-container *ngIf="origin != 'Total'">
                  <th class="border-count-events-left">
                    {{ origin }}
                  </th>
                </ng-container>
              </ng-container>

              <th class="border-count-events-left">
                <ng-container *ngIf="!btnMinimizeCountEventTypeWindow">
                  <i
                    class="fa fa-window-minimize"
                    aria-hidden="true"
                    style="cursor: pointer"
                    (click)="btnMinimizeCountEventTypeWindow = true"
                  ></i>
                </ng-container>
                <ng-container *ngIf="btnMinimizeCountEventTypeWindow">
                  <i
                    class="fa fa-window-maximize"
                    aria-hidden="true"
                    style="cursor: pointer"
                    (click)="btnMinimizeCountEventTypeWindow = false"
                  ></i>
                </ng-container>
              </th>
            </thead>
            <tbody>
              <ng-container *ngFor="let key of getKeys(countEventType, true)">
                <ng-container *ngIf="key != 'messageOrigin'">
                  <tr>
                    <td>{{ key }}</td>
                    <td class="border-count-events-left bold">
                      {{ getValue(countEventType, key, "Total") }}
                    </td>
                    <ng-container
                      *ngFor="let origin of countEventType.messageOrigin"
                    >
                      <ng-container *ngIf="origin != 'Total'">
                        <td class="border-count-events-left">
                          {{ getValue(countEventType, key, origin) }}
                        </td>
                      </ng-container>
                    </ng-container>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div></ng-container
      >

      <!-- Dialog Analytics -->
      <ng-template #modalAnalytics let-modal>
        <div class="modal-header">
          <h5 class="modal-title mt-0">Análise de dados</h5>
          <button
            type="button"
            class="btn btn-close"
            (click)="modal.dismiss('Cross click'); modalInstance = undefined"
            aria-hidden="true"
          ></button>
        </div>
        <div class="modal-body">
          <div class="h-75">
            <div class="card">
              <div class="card-body">
                <!-- Nav tabs -->
                <ul
                  ngbNav
                  #customNav="ngbNav"
                  [activeId]="1"
                  class="nav nav-tabs nav-tabs-custom"
                >
                  <li [ngbNavItem]="1">
                    <a ngbNavLink>
                      <span class="d-block d-sm-none"
                        ><i class="fas fa-android"></i
                      ></span>
                      <span class="d-none d-sm-block">Contagem de eventos</span>
                    </a>
                    <ng-template ngbNavContent>
                      <ng-template
                        [ngTemplateOutlet]="TabCountEvents"
                      ></ng-template>
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="2">
                    <a ngbNavLink>
                      <span class="d-block d-sm-none"
                        ><i class="fas fa-table"></i
                      ></span>
                      <span class="d-none d-sm-block">Eventos em Grid</span>
                    </a>
                    <ng-template ngbNavContent>
                      <ng-template
                        [ngTemplateOutlet]="TabAnalyticGridEvent"
                      ></ng-template>
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="3">
                    <a ngbNavLink>
                      <span class="d-block d-sm-none"
                        ><i class="fas fa-battery"></i
                      ></span>
                      <span class="d-none d-sm-block">Análise Bateria</span>
                    </a>
                    <ng-template ngbNavContent>
                      <ng-template
                        [ngTemplateOutlet]="TabAnalyticBattery"
                      ></ng-template>
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="4">
                    <a ngbNavLink>
                      <span class="d-block d-sm-none"
                        ><i class="fas fa-signal"></i
                      ></span>
                      <span class="d-none d-sm-block">Análise GSM/GPS</span>
                    </a>
                    <ng-template ngbNavContent>
                      <ng-template
                        [ngTemplateOutlet]="TabAnalyticGsmGPS"
                      ></ng-template>
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="5">
                    <a ngbNavLink>
                      <span class="d-block d-sm-none"
                        ><i class="fas fa-signal"></i
                      ></span>
                      <span class="d-none d-sm-block"
                        >Análise Chegada de Pacotes</span
                      >
                    </a>
                    <ng-template ngbNavContent>
                      <ng-template
                        [ngTemplateOutlet]="TabAnalyticArrivedData"
                      ></ng-template>
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="6">
                    <a ngbNavLink>
                      <span class="d-block d-sm-none"
                        ><i class="fas fa-car"></i
                      ></span>
                      <span class="d-none d-sm-block">Análise UBI</span>
                    </a>
                    <ng-template ngbNavContent>
                      <ng-template
                        [ngTemplateOutlet]="TabAnalyticUBI"
                      ></ng-template>
                    </ng-template>
                  </li>
                </ul>

                <!-- Tab panes -->
                <div class="tab-content p-3 text-muted">
                  <div [ngbNavOutlet]="customNav"></div>
                </div>
              </div>
              <!-- end card body -->
            </div>
            <!-- end card -->
          </div>
          <!-- end col -->
        </div>
      </ng-template>
      <!--Fim Dialog-->

      <!-- Tab Contagem de Eventos -->
      <ng-template #TabCountEvents>
        <ng-select
          class="w-50 mb-3"
          id="fileTypeSelect"
          placeholder="Selecione um tipo de arquivo"
          [(ngModel)]="graphFieldSelect"
          (change)="countEventGraphBarMountAndTable(graphFieldSelect)"
        >
          <ng-option *ngFor="let field of graphField" [value]="field">
            {{ field }}
          </ng-option>
        </ng-select>
        <div class="w-50" style="display: block">
          <div class="card align-items-center">
            <strong>
              {{
                positionEventJson.length > 0
                  ? serial +
                    " - " +
                    positionEventJson[0].data_hora_evento +
                    " até " +
                    positionEventJson[positionEventJson.length - 1]
                      .data_hora_evento
                  : ""
              }}
            </strong>
          </div>
          <canvas
            [ngClass]="{ 'd-none': barChartData.length < 1 }"
            baseChart
            [datasets]="barChartData"
            [labels]="barChartLabels"
            [options]="barChartOptions"
            [plugins]="barChartPlugins"
            [legend]="barChartLegend"
            chartType="barChartType"
          >
          </canvas>
        </div>
        <div class="input-group input-group-sm mb-2">
          <span class="input-group-text">Filtro de número sequencial</span>
          <ui-switch
            #filterSequenceNumberSwitch
            class="ms-2"
            defaultBgColor="#F44336"
            defaultBoColor="#dfdfdf"
            color="#038edc"
            checkedLabel="True"
            uncheckedLabel="False"
            [checked]="filterSequenceNumber"
            ngbTooltip='não entram para a contagem as posições com mesma data hora evento e
        mesmo numero sequencial, por exemplo: "10-10-2020 459"'
            (change)="
              changeFlagButtonFilterSequenceNumber(filterSequenceNumberSwitch);
              countEventGraphBarMountAndTable(graphFieldSelect)
            "
          ></ui-switch>
        </div>
        <ng-container *ngIf="filterSequenceNumber">
          <div>
            ** não entram para a contagem as posições com mesma data hora evento
            e mesmo numero sequencial, por exemplo: "10-10-2020 459"
          </div>
        </ng-container>

        <div class="h-75">
          <pre
            id="tableCountEventHTMLString"
            [innerHTML]="tableCountEventHTMLString"
          ></pre>
        </div>
      </ng-template>

      <!-- Tab Graph Battery -->
      <ng-template #TabAnalyticBattery>
        <div>
          <label class="form-check-label" for="formCheckEventDetectionP2P">
            Desconsiderar eventos DETECCAO_P2P
          </label>
          <input
            class="form-check-input ms-2"
            type="checkbox"
            [(ngModel)]="lineChartFilterDetectionP2PBattery"
            checked="true"
            unchecked="false"
          />
        </div>
        <div>
          <label class="form-check-label" for="formCheckOrigin">
            Desconsiderar origem LORA_P2P
          </label>
          <input
            class="form-check-input ms-2"
            type="checkbox"
            [(ngModel)]="lineChartFilterOriginP2PBattery"
            checked="true"
            unchecked="false"
          />
        </div>
        <div>
          <label class="form-check-label" for="formCheckPercent">
            Bateria interna em Porcentagem (%)
          </label>
          <input
            class="form-check-input ms-2"
            type="checkbox"
            [(ngModel)]="lineChartFilterPercentBattery"
            checked="true"
            unchecked="false"
          />
        </div>
        <div>
          <label class="form-check-label" for="formInternalBattery">
            Incluir Bateria Interna
          </label>
          <input
            class="form-check-input ms-2"
            type="checkbox"
            [(ngModel)]="lineChartFilterInternalBattery"
            checked="true"
            unchecked="false"
          />
        </div>
        <div>
          <label class="form-check-label" for="formCheckEstimated">
            Incluir tempo estimado
          </label>
          <input
            class="form-check-input ms-2"
            type="checkbox"
            [(ngModel)]="lineChartFilterTimeEstimatedBattery"
            checked="true"
            unchecked="false"
          />
        </div>
        <div>
          <label class="form-check-label" for="formIgn">
            Incluir Ignição ON e OFF
          </label>
          <input
            class="form-check-input ms-2"
            type="checkbox"
            [(ngModel)]="lineChartBatteryIgn"
            checked="true"
            unchecked="false"
          />
        </div>
        <div>
          <label class="form-check-label" for="formIgn">
            Incluir Eventos de bateria externa
          </label>
          <input
            class="form-check-input ms-2"
            type="checkbox"
            [(ngModel)]="lineChartDeconectBattery"
            checked="true"
            unchecked="false"
          />
        </div>
        <div class="row">
          <div class="col-md">
            <ng-select
              class="w-50 mb-3"
              id="unitChartLine2"
              placeholder="Selecione um tipo de arquivo"
              [(ngModel)]="lineChartOptionsStepUnit"
              (change)="changeUnitLineChart()"
            >
              <ng-option value="seconds"> Segundos </ng-option>
              <ng-option value="minute"> Minutos </ng-option>
              <ng-option value="hour"> Horas </ng-option>
            </ng-select>
          </div>
          <div class="col-md">
            <label
              >Tempo ({{ lineChartOptionsStepUnit.substring(0, 1) }})</label
            >
            <input
              type="number"
              min="0"
              class="ms-2"
              (change)="changeUnitLineChart()"
              [(ngModel)]="lineChartOptionsStepSize"
            />
          </div>
        </div>

        <button
          class="btn btn-primary align-items-center"
          (click)="mountGraphLineBattery()"
        >
          Gerar gráfico bateria
        </button>
        <div class="w-75" style="display: block">
          <div class="card align-items-center">
            <strong>
              {{
                positionEventJson.length > 0
                  ? serial +
                    " - " +
                    positionEventJson[positionEventJson.length - 1]
                      .data_hora_evento +
                    " até " +
                    positionEventJson[0].data_hora_evento
                  : ""
              }}
            </strong>
          </div>
          <canvas
            id="chart"
            [ngClass]="{ 'd-none': lineChartDataBattery.length < 1 }"
            baseChart
            [datasets]="lineChartDataBattery"
            [labels]="lineChartLabelsBattery"
            [options]="lineChartOptions"
            colors="lineChartColors"
            [type]="lineChartType"
            [legend]="barChartLegend"
            [plugins]="lineChartPlugins"
          >
          </canvas>
        </div>
      </ng-template>

      <!-- Tab Gsm e GPS -->
      <ng-template #TabAnalyticGsmGPS>
        <div>
          <label class="form-check-label" for="formCheckEventDetectionP2P">
            Desconsiderar eventos DETECCAO_P2P
          </label>
          <input
            class="form-check-input ms-2"
            type="checkbox"
            [(ngModel)]="lineChartFilterDetectionP2PGsmGps"
            checked="true"
            unchecked="false"
          />
        </div>
        <div>
          <label class="form-check-label" for="formCheckOrigin">
            Desconsiderar origem LORA_P2P
          </label>
          <input
            class="form-check-input ms-2"
            type="checkbox"
            [(ngModel)]="lineChartFilterOriginP2PGsmGps"
            checked="true"
            unchecked="false"
          />
        </div>
        <button
          class="btn btn-primary align-items-center"
          (click)="mountGraphLineGsmGPS(gsm, gps, rede4g)"
        >
          Gerar gráfico GSM, REDE_4G e GPS
        </button>
        <div>
          <label>GSM</label>
          <input #gsm checked="true" unchecked="false" type="checkbox" />
        </div>
        <div>
          <label>REDE_4G</label>
          <input #rede4g checked="true" unchecked="false" type="checkbox" />
        </div>
        <div>
          <label>GPS</label>
          <input #gps checked="true" unchecked="false" type="checkbox" />
        </div>
        <div class="row">
          <div class="col-md">
            <ng-select
              class="w-50 mb-3"
              id="unitChartLine1"
              placeholder="Selecione um tipo de arquivo"
              [(ngModel)]="lineChartOptionsStepUnit"
              (change)="changeUnitLineChart()"
            >
              <ng-option value="seconds"> Segundos </ng-option>
              <ng-option value="minute"> Minutos </ng-option>
              <ng-option value="hour"> Horas </ng-option>
            </ng-select>
          </div>
          <div class="col-md">
            <label
              >Tempo ({{ lineChartOptionsStepUnit.substring(0, 1) }})</label
            >
            <input
              type="number"
              min="0"
              class="ms-2"
              (change)="changeUnitLineChart()"
              [(ngModel)]="lineChartOptionsStepSize"
            />
          </div>
        </div>
        <div class="w-75" style="display: block">
          <div class="card align-items-center">
            <strong>
              {{
                positionEventJson.length > 0
                  ? serial +
                    " - " +
                    positionEventJson[positionEventJson.length - 1]
                      .data_hora_evento +
                    " até " +
                    positionEventJson[0].data_hora_evento
                  : ""
              }}
            </strong>
          </div>
          <canvas
            [ngClass]="{ 'd-none': lineChartData.length < 1 }"
            baseChart
            [datasets]="lineChartData[0]"
            [labels]="lineChartLabels[0]"
            [options]="lineChartOptions"
            colors="lineChartColors"
            [type]="lineChartType"
            [legend]="barChartLegend"
            [plugins]="lineChartPlugins"
          >
          </canvas>
        </div>
      </ng-template>
    </div>
    <!-- Tab Diff Date Arrived -->
    <ng-template #TabAnalyticArrivedData>
      <div>
        <label class="form-check-label" for="formCheckEventDetectionP2P">
          Desconsiderar eventos DETECCAO_P2P
        </label>
        <input
          class="form-check-input ms-2"
          type="checkbox"
          [(ngModel)]="lineChartFilterDetectionP2PGsmGps"
          checked="true"
          unchecked="false"
        />
      </div>
      <div>
        <label class="form-check-label" for="formCheckOrigin">
          Desconsiderar origem LORA_P2P
        </label>
        <input
          class="form-check-input ms-2"
          type="checkbox"
          [(ngModel)]="lineChartFilterOriginP2PGsmGps"
          checked="true"
          unchecked="false"
        />
      </div>
      <button
        class="btn btn-primary align-items-center"
        (click)="mountGraphLineArrivedData()"
      >
        Gerar gráfico Chegada dos pacotes
      </button>

      <div class="row">
        <div class="col-md">
          <ng-select
            class="w-50 mb-3"
            id="unitChartLine1"
            placeholder="Selecione um tipo de arquivo"
            [(ngModel)]="lineChartOptionsStepUnit"
            (change)="changeUnitLineChart()"
          >
            <ng-option value="seconds"> Segundos </ng-option>
            <ng-option value="minute"> Minutos </ng-option>
            <ng-option value="hour"> Horas </ng-option>
          </ng-select>
        </div>
        <div class="col-md">
          <label>Tempo ({{ lineChartOptionsStepUnit.substring(0, 1) }})</label>
          <input
            type="number"
            min="0"
            class="ms-2"
            (change)="changeUnitLineChart()"
            [(ngModel)]="lineChartOptionsStepSize"
          />
        </div>
      </div>
      <div class="w-75" style="display: block">
        <div class="card align-items-center">
          <strong>
            {{
              positionEventJson.length > 0
                ? serial +
                  " - " +
                  positionEventJson[positionEventJson.length - 1]
                    .data_hora_evento +
                  " até " +
                  positionEventJson[0].data_hora_evento
                : ""
            }}
          </strong>
        </div>
        <canvas
          [ngClass]="{ 'd-none': lineChartData.length < 1 }"
          baseChart
          [datasets]="lineChartData[2]"
          [labels]="lineChartLabels[2]"
          [options]="lineChartOptions"
          colors="lineChartColors"
          [type]="lineChartType"
          [legend]="barChartLegend"
          [plugins]="lineChartPlugins"
        >
        </canvas>
      </div>
    </ng-template>

    <!-- Tab UBI -->
    <ng-template #TabAnalyticUBI>
      <div>
        <button
          class="btn btn-primary align-items-center"
          (click)="mountGraphLineUBI(speedGPS, rpm, speedCAN)"
        >
          Gerar gráfico UBI
        </button>
        <div>
          <label>Velocidade GPS</label>
          <input #speedGPS checked="true" unchecked="false" type="checkbox" />
        </div>
        <div>
          <label>Velocidade CAN</label>
          <input #speedCAN checked="true" unchecked="false" type="checkbox" />
        </div>
        <div>
          <label>RPM</label>
          <input #rpm checked="true" unchecked="false" type="checkbox" />
        </div>
        <div class="row">
          <div class="col-md">
            <ng-select
              class="w-50 mb-3"
              id="unitChartLine1"
              placeholder="Selecione um tipo de arquivo"
              [(ngModel)]="lineChartOptionsStepUnit"
              (change)="changeUnitLineChart()"
            >
              <ng-option value="seconds"> Segundos </ng-option>
              <ng-option value="minute"> Minutos </ng-option>
              <ng-option value="hour"> Horas </ng-option>
            </ng-select>
          </div>
          <div class="col-md">
            <label
              >Tempo ({{ lineChartOptionsStepUnit.substring(0, 1) }})</label
            >
            <input
              type="number"
              min="0"
              class="ms-2"
              (change)="changeUnitLineChart()"
              [(ngModel)]="lineChartOptionsStepSize"
            />
          </div>
        </div>
        <div class="w-75" style="display: block">
          <div class="card align-items-center">
            <strong>
              {{
                positionEventJson.length > 0
                  ? serial +
                    " - " +
                    positionEventJson[positionEventJson.length - 1]
                      .data_hora_evento +
                    " até " +
                    positionEventJson[0].data_hora_evento
                  : ""
              }}
            </strong>
          </div>
          <canvas
            [ngClass]="{ 'd-none': lineChartData.length < 1 }"
            baseChart
            [datasets]="lineChartData[1]"
            [labels]="lineChartLabels[1]"
            [options]="lineChartOptions"
            colors="lineChartColors"
            [type]="lineChartType"
            [legend]="barChartLegend"
            [plugins]="lineChartPlugins"
          >
          </canvas>
        </div>
      </div>
    </ng-template>

    <ng-template #TabAnalyticGridEvent>
      <div>
        <button
          class="btn btn-primary align-items-center"
          (click)="onClickChangeGrid(undefined, undefined)"
        >
          Montar eventos em tabela
        </button>

        <div class="w-75" style="display: block">
          <div class="card align-items-center">
            <strong>
              {{
                positionEventJson.length > 0
                  ? serial +
                    " - " +
                    positionEventJson[positionEventJson.length - 1]
                      .data_hora_evento +
                    " até " +
                    positionEventJson[0].data_hora_evento
                  : ""
              }}
            </strong>
          </div>
        </div>
        <div
          class="row d-flex"
          style="
            display: flex !important;
            max-height: 150px;
            overflow: auto;
            flex-wrap: nowrap;
          "
        >
          <ng-container *ngFor="let key of getKeys(filterGridEvents)">
            <div
              class="card col-md"
              style="flex-basis: fit-content; height: max-content"
            >
              <div style="align-self: center">
                <input
                  type="checkbox"
                  (ngModelChange)="this.onClickChangeGrid(key, undefined)"
                />
                <label>{{ key }}</label>
              </div>
              <ng-container *ngIf="getKeys(filterGridEvents[key]).length > 2">
                <ng-container
                  *ngFor="let subKey of getKeys(filterGridEvents[key])"
                >
                  <ng-container *ngIf="subKey != 'all'">
                    <div>
                      <input
                        [disabled]="filterGridEvents[key]['all']"
                        type="checkbox"
                        (ngModelChange)="this.onClickChangeGrid(key, subKey)"
                      />
                      <label>{{ subKey }}</label>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>
          </ng-container>
        </div>
        <div class="card align-items-center" *ngIf="circularProgressiveWait">
          <div card="card-body mt-n3">
            <div class="spinner-border text-primary m-1" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
        <div [fluidHeight] style="max-height: 65vh">
          <ng-container *ngIf="jsonEventsGrid.length > 0">
            <table class="table table-bordered" datatable>
              <thead>
                <tr>
                  <ng-container *ngFor="let key of getKeys(jsonEventsGrid[0])">
                    <th>
                      <label>{{
                        key.replace(".", " ").replace(",", " ")
                      }}</label>
                      <i
                        class="fa fa-window-close ms-1"
                        aria-hidden="true"
                        style="cursor: pointer; color: red"
                        (click)="
                          onClickFilterCheckBoxEventGrid(
                            filterGridEvents,
                            '',
                            key,
                            false
                          )
                        "
                      ></i>
                    </th>
                  </ng-container>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let event of jsonEventsGrid">
                  <ng-container *ngFor="let key of getKeys(jsonEventsGrid[0])">
                    <td>{{ getValue(event, key) }}</td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </ng-container>
        </div>
      </div>
    </ng-template>
  </div>
</div>
